import { Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { VitalIconItem } from '../card/patient-card/patient-card.component';

@Component({
  selector: 'formly-mat-icon',
  template: `
    <mat-icon
      [svgIcon]="to['iconName']"
      [color]="to['color']"
      [class]="to['className']">
    </mat-icon>
  `
})
export class MatIconType extends FieldType<FieldTypeConfig> implements OnInit {
  private readonly iconItems: VitalIconItem[] = [
    { iconPath: 'assets/images/icon/time-icon.svg', iconName: 'time-icon' },
    { iconPath: 'assets/images/icon/blood-pressure.svg', iconName: 'blood-pressure-icon' },
    { iconPath: 'assets/images/icon/breath.svg', iconName: 'breath-icon' },
    { iconPath: 'assets/images/icon/heart-rate.svg', iconName: 'heart-rate-icon' },
    { iconPath: 'assets/images/icon/oxygen.svg', iconName: 'oxygen-icon' },
    { iconPath: 'assets/images/icon/sleep.svg', iconName: 'sleep-icon' },
    { iconPath: 'assets/images/icon/step.svg', iconName: 'step-icon' },
    { iconPath: 'assets/images/icon/temperature.svg', iconName: 'temperature-icon' },
    { iconPath: 'assets/images/icon/level.svg', iconName: 'level-icon' }
  ];

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    super();
    this.registerIcons();
  }
  ngOnInit(): void {
  }

  private registerIcons(): void {
    this.iconItems.forEach(icon => {
      this.matIconRegistry.addSvgIcon(
        icon.iconName,
        this.domSanitizer.bypassSecurityTrustResourceUrl(icon.iconPath)
      );
    });
  }
}